import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { formatFileName } from './formatters';
import { defaultParser, sectionParserMap } from './parsers';
import { getCustomerInfo } from '@src/globalStore/profileStore';

// main header for the top of the csv
export function buildMainHeader(customerName: string) {
  const timeNow = moment();
  const headers = [
    '\uFEFF',
    'Report generated by Conviva Pulse.',
    "This report must be used in conformance with customer's",
    'Subscription Agreement & Data Policy with Conviva.',
    `Report generated on ${timeNow.toString().replace('GMT', 'UTC')}`,
    `Account Name: ${customerName}`,
    'Copyright ' + timeNow.format('Y') + ' Conviva Inc.',
    'Conviva Confidential \r\n',
  ];
  return headers.join('\r\n');
}

export function downloadCsv(csv, filename) {
  const link = document.createElement('a');
  link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
  link.setAttribute('download', formatFileName(filename));
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function buildCsv({ data, config }) {
  const { customerName } = getCustomerInfo();

  // Pages may register the specific set of accounts the export covers (e.g. the
  // Usage Dashboard lists every selected c3 account). Fall back to the
  // logged-in account name when no explicit list is provided.
  const accountNames = get(data, ['meta', 'accountNames']);
  const headerAccountName =
    Array.isArray(accountNames) && accountNames.length ? accountNames.join(', ') : customerName;

  const csvParts: any = [];
  csvParts.push(buildMainHeader(headerAccountName));

  if (data) {
    config.sections.forEach((section: any) => {
      const { key, parser = null } = section;

      // sections
      if (key in data.sections) {
        const sectionData = data.sections[key];

        // custom, predefined section specific or default parsing
        if (!isEmpty(sectionData)) {
          const sectionParser = parser || sectionParserMap[key] || defaultParser;
          csvParts.push(sectionParser({ section, sectionData }));
        }
      }
    });
  }
  downloadCsv(csvParts.join('\r\n'), config.page.title);
}

export default buildCsv;
